import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { DataSource, RequestMetadata, PagedResult, DataType } from 'lib/ng-crud-table';
import { NotifyService } from 'lib/notify/notify.service';
import { environment } from 'src/environments/environment';
//import { environment } from '../../environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class FiltersService implements DataSource {
  url: string = 'assets/ng-crud-table/players.json';

  primaryKeys: string[] = ['id'];

  constructor(private http: HttpClient, private notifyService: NotifyService) {

  }

  //Clear All Filters - IMP
  clearAllFilters() {

  }

  getConfigsList(type: number, FilterID: string) {
    let params = new HttpParams()
      .set('type', type.toString())
      .set('FilterID', FilterID);

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    };

    this.url = environment.urlAddress + '/api/MainFilters/GetFiltersData';
    return this.http.get<any>(this.url, options);
  }

  GetTimeZoneDatePeriod_Service(mainFilterID: number, custDates:string) {
    
    let params = new HttpParams()
      .set('mainFilterID', mainFilterID.toString())
      .set('CustDT', custDates);

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers,
      params: params
    };

    this.url = environment.urlAddress + '/api/MainFilters/GetTimeZoneDatePeriod';
    return this.http.get<any>(this.url, options);
  }

  Rows: string = "";
  //RowsCommon: string = "";
  //Latest filters rows set here
  setRows(data) {//, commonOrMain) {
    //if (commonOrMain == 0)
    //  this.RowsCommon = data;
    //else
      this.Rows = data;
  }

  async getItems(requestMeta: RequestMetadata): Promise<PagedResult> {
    //console.log(requestMeta.pageMeta)
    const currentPage = requestMeta.pageMeta.currentPage;
    const perPage = requestMeta.pageMeta.perPage;
    const pageCount = requestMeta.pageMeta.pageCount;
    //console.log(requestMeta.rsltType)
    const data = this.Rows; //requestMeta.rsltType == "0" ? this.RowsCommon : this.Rows;
    const rows: any[] = JSON.parse(data) as any[] || [];
    //console.log(rows)
    if (requestMeta.rsltType == "0") {
      //https://www.codegrepper.com/code-examples/typescript/typescript+sort+json+array+by+property
      rows.sort((a, b) => (a.Column_Name > b.Column_Name) ? 1 : -1)
    }
    else {
      rows.sort((a, b) => (a.Result_Type > b.Result_Type) ? 1 : -1);
    }

    const totalCount = rows.length;
    const result = {
      items: rows,
      _meta: {
        totalCount,//number of records totally
        pageCount,//number of records in current page
        currentPage,//page number selected
        perPage//selected option for number of records to be actually displayed
      }
    } as PagedResult;
    //console.log('filters done')
    return result;
  }

  getItemsByID(requestMeta: RequestMetadata): Promise<PagedResult> {
    throw new Error("Method not implemented.");
  }
  getItem(row: any): Promise<any> {
    const filters = {};
    for (const key of this.primaryKeys) {
      filters[key] = { value: row[key] };
    }
    const requestMeta = {
      pageMeta: { currentPage: 1 },
      filters,
    } as RequestMetadata;
    return this.getItems(requestMeta)
      .then(data => data.items[0]);
  }

  post(item: any, methodName): Promise<number> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };
    //console.log(item)
    this.url = environment.urlAddress + '/api/MainFilters/' + methodName;
    //https://www.positronx.io/angular-promises-example-manage-http-requests/
    return this.http
      .post<number>(this.url, item)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  put(item: any, methodName): Promise<number> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };
    this.url = environment.urlAddress + '/api/MainFilters/' + methodName;

    return this.http
      .put<number>(this.url, item)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  GetData_Service(controllerPlusMethod) {
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    this.url = environment.urlAddress + controllerPlusMethod;

    return this.http.post<any>(this.url, options);
  }

  delete(row: any, methodName): Promise<any> {
    let IDOrName = (row.split(','))[0];
    let LoggedinUserName = (row.split(','))[1];
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };
    ////  /api/SchedulerReport/CheckSchNameByFilterName?filterName=' + delCriteriaName
    //this.url = environment.urlAddress + '/api/MainFilters/' + methodName + '/' + IDOrName + '/' + LoggedinUserName;
    this.url = environment.urlAddress + '/api/MainFilters/' + methodName + '?id=' + IDOrName + '&LoggedinUserName=' + LoggedinUserName;

    return this.http
      .delete<number>(this.url, options)
      .toPromise()
      .then(function (res) {
        return res;
      }.bind(this))
      .catch(this.handleError.bind(this));
  }

  getOptions(url: string, parentId: any): Promise<any> {
    return this.http.get(url)
      .toPromise()
      .then((response: any) => {
        const result = response.filter((value: any) => {
          return value.parentId === parentId;
        });
        return new Promise((resolve) => {
          setTimeout(() => resolve(result), 1000);
        });
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    this.notifyService.sendMessage({ title: 'HttpErrorResponse', text: errorMessage, severity: 'error' });
    return Promise.reject(errorMessage);
  }

  getItemTest(requestMeta: RequestMetadata) {
    return null;
  }
  getItem_AsyncTest(requestMeta: RequestMetadata): Promise<PagedResult> {
    return null;
  }
  ////set curr config from DB and load on table
  //setConfigFromDB(row: MAINFILTER) {

  //  this.mainFilter = row;

  //  //Call ID, Device, ID and Event ID
  //  this.Rows = '';

  //  let commonValObj = { "VQuad_Location": this.mainFilter.VQuad_Location, "VQuad_DeviceID": this.mainFilter.VQuad_PhoneID, "VQuad_EventID": this.mainFilter.VQuad_CallID };
  //  for (const key in commonValObj) {
  //    if (commonValObj[key] != null) {
  //      if (commonValObj[key].length > 0) {
  //        let commonValList = commonValObj[key].split(';');

  //        commonValList.forEach((eachCommonVal) => {
  //          this.ReloadSelMultiCriteria(eachCommonVal);
  //          this.operAndCritList.forEach((eachOperAndCrit, i) => {
  //            let row = '{"Column_Name":"' + GetMapColumnAliia(key, "", "") + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
  //            this.Rows += row + ',';
  //          });
  //        });
  //      }
  //    }
  //  }


  //  //Main results and params
  //  let rangeListObj = {
  //    "0|PESQ_LQ": this.mainFilter.PESQ_LQ_Range, "1|POLQA_Score": this.mainFilter.POLQA_Score_Range,
  //    "2|RTD": this.mainFilter.RTD_Range, "2|OWD": this.mainFilter.OWD_Range, "2|SWR": this.mainFilter.SNR_Range, "2|PDD": this.mainFilter.PDD_Range,
  //    "17|MOS_CQ": this.mainFilter.MOSCQ_Range
  //  };
  //  for (const key in rangeListObj) {
  //    if (rangeListObj[key] != null) {
  //      if (rangeListObj[key].length > 0) {
  //        let rsltAndParamList = key.split('|');
  //        let rsltDetails = this.results.find(x => x.id === parseInt(rsltAndParamList[0]));

  //        let currRangeList = rangeListObj[key].split('|');
  //        let andOrVal = "AND";
  //        if (currRangeList.length == 3)
  //          andOrVal = currRangeList[2];
  //        let row = '{"Column_OrigName":"' + rsltAndParamList[1] + '","NumOrRatingOrStr":"1","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + GetMapColumnAliia(rsltAndParamList[1], "", "") + '","Operator":"' + (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1] + '","Value":"' + currRangeList[0] + '","Value_To":"' + currRangeList[1] + '","AndOr":"' + andOrVal + '"}';
  //        this.Rows += row + ',';
  //      }
  //    }
  //  };

  //  let ratingListObj = { "0|Rating": this.mainFilter.PESQ_LQ_Rating, "2|RTD_Rating": this.mainFilter.RTD_Rating, "17|VBA_Rating": this.mainFilter.MOSCQ_Rating };
  //  for (const key in ratingListObj) {
  //    if (rangeListObj[key] != null) {
  //      if (ratingListObj[key].length > 0) {
  //        let rsltAndParamList = key.split('|');
  //        let rsltDetails = this.results.find(x => x.id === parseInt(rsltAndParamList[0]));

  //        let currRatingList = ratingListObj[key].split('|');
  //        let ratingOper = "";
  //        let ratingVal = "";
  //        let andOrRange = 3;
  //        if (rsltAndParamList[0] == "0") {
  //          ratingOper = this.selRatingParamOperators[parseInt(currRatingList[0])].value;//Rating operator
  //          ratingVal = this.PESQRating.find(x => x.id == parseInt(currRatingList[1])).name;//value dropdown
  //        }
  //        else if (rsltAndParamList[0] == "2") {
  //          ratingOper = this.selRatingParamOperators[parseInt(currRatingList[0])].value;//Rating operator
  //          ratingVal = this.RTDRating.find(x => x.id == parseInt(currRatingList[1])).name;//value dropdown
  //        }
  //        if (rsltAndParamList[0] == "17") {
  //          ratingOper = this.selRatingParamOperators[2].value;
  //          ratingVal = this.MOSRating.find(x => x.id == parseInt(currRatingList[0])).name;//value dropdown
  //          andOrRange = 2;
  //        }
  //        let andOrVal = "AND";
  //        if (currRatingList.length == andOrRange)
  //          andOrVal = currRatingList[2];
  //        let row = '{"Column_OrigName":"' + rsltAndParamList[1] + '","NumOrRatingOrStr":"2","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + GetMapColumnAliia(rsltAndParamList[1], "", "") + '","Operator":"' + (this.dataFilter.getOperatorType(ratingOper))[1] + '","Value":"' + ratingVal + '","Value_To":"--","AndOr":"' + andOrVal + '"}';
  //        this.Rows += row + ',';
  //      }
  //    }
  //  };

  //  //0, 1
  //  //VQT@|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$Or|VQTData|duration_hangover|LIKE|2|Duration Hangover(s)$ - params after @ and delimited $
  //  //|VQTData|Asymmetric_disturbance|=|1|Asymmetric disturbance$ - AND/OR  |  Table name   |   Parameter name   |  operator(=/>/</LIKE) | value  |  Alias Param name $
  //  let critConditionsList = [this.mainFilter.CriteriaCondition, this.mainFilter.POLQACriteriaCondition];
  //  critConditionsList.forEach((eachRsltCrit, i) => {
  //    if (eachRsltCrit != null) {
  //      if (eachRsltCrit.length > 0) {
  //        let allParamsCrit = (eachRsltCrit.split('@'))[1];
  //        let colsList = allParamsCrit.substring(0, allParamsCrit.length - 1).split('$');// remove last $
  //        colsList.forEach(eachCol => {
  //          let colDetailsList = eachCol.split('|');
  //          let rsltDetails = this.results.find(x => x.id === i);//0, 1
  //          let oper = FilterOperator.EQUALS;
  //          let operType = 1;
  //          if (isNaN(Number(colDetailsList[3]))) {
  //            if (colDetailsList[3] == ">")
  //              oper = FilterOperator.GREATER_THAN;
  //            else if (colDetailsList[3] == "<")
  //              oper = FilterOperator.LESS_THAN;
  //            else if (colDetailsList[3] == "LIKE")
  //              oper = FilterOperator.CONTAINS;
  //          }
  //          else {
  //            let numericOrNot = this.getCurrColType(rsltDetails.alias, rsltDetails.parentId, colDetailsList[2]);
  //            operType = numericOrNot == true ? 1 : 3;
  //            oper = numericOrNot == true ? this.rangeOperators.find(x => x.value == parseInt(colDetailsList[3])) : this.stringOperators.find(x => x.value == parseInt(colDetailsList[3]));
  //          }

  //          let row = '{"Column_OrigName":"' + colDetailsList[5] + '","NumOrRatingOrStr":"' + operType + '","Result_Type":"' + rsltDetails.name + '","Column_Name":"' + colDetailsList[5] + '","Operator":"' + (this.dataFilter.getOperatorType(oper))[1] + '","Value":"' + colDetailsList[4] + '","Value_To":"--","AndOr":"' + colDetailsList[0] + '"}';
  //          this.Rows += row + ',';
  //        });
  //      }
  //    }
  //  });

  //  //3-11
  //  //;;;;;;;; - nettest
  //  //AND$1:333@9^OR$9:999@1;AND$2:777@2;AND$3:444@2;;;;;;AND$6:766@2 - delimited by ; for each nettest rslt type

  //  //AND$1:333@9^OR$9:999@1 - delimited by ^ for each param under curr rslt
  //  //AND$1:333@9 - AND/OR   $   1(Low) : 333(High)   @   9(param index)
  //  //; as delimiter between rslt types

  //  let netAndMobList = [this.mainFilter.NetTest, this.mainFilter.Mobile];
  //  netAndMobList.forEach((eachRsltCrit, i) => {
  //    if (eachRsltCrit != null) {
  //      if (eachRsltCrit.length > 0) {
  //        let currRsltList = eachRsltCrit.split(';');
  //        currRsltList.forEach((eachsubrslt, i) => {
  //          if (eachsubrslt.length > 0) {
  //            let rsltDetails = this.results.find(x => x.id === i);
  //            let colsList = eachsubrslt.replace(/^OR/g, '&OR').replace(/^AND/g, '&AND').split('&');//To avoid confict of param split with doesnot contain operator

  //            colsList.forEach(eachCol => {
  //              let andOrCritList = (eachCol.split('@'))[0].split('$');
  //              let colIndx = ',"Column_Index":"' + (eachCol.split('@'))[1] + '"';

  //              let numericOrNot = this.getCurrColType(rsltDetails.alias, rsltDetails.parentId, (eachCol.split('@'))[1]);
  //              if (numericOrNot == false) {

  //                this.ReloadSelMultiCriteria(andOrCritList[1], '~');
  //                this.operAndCritList.forEach((eachOperAndCrit, i) => {
  //                  let row = '{"Column_OrigName":"' + this.colNameTbl + '","NumOrRatingOrStr":"3"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + this.colNameTbl + '","Operator":"' + (this.dataFilter.getOperatorType(eachOperAndCrit.oper))[1] + '","Value":"' + eachOperAndCrit.critVal + '","AndOr":"OR"}';
  //                  this.Rows += row + ',';
  //                });
  //              }
  //              else {
  //                let row = '{"Column_OrigName":"' + this.colNameTbl + '","NumOrRatingOrStr":"1"' + colIndx + ',"Result_Type":"' + rsltDetails.name + '","Column_Name":"' + this.colNameTbl + '","Operator":"' + (this.dataFilter.getOperatorType(FilterOperator.IN_RANGE))[1] + '","Value":"' + (andOrCritList[1].split(':'))[0] + '","Value_To":"' + (andOrCritList[1].split(':'))[1] + '","AndOr":"' + andOrCritList[0] + '"}';
  //                this.Rows += row + ',';
  //              }
  //            });
  //          }
  //        });
  //      }
  //    }
  //  });
  //  this.colNameTbl = "";

  //  //if (this.Rows.length > 0)
  //  //  this.Rows = '[' + this.Rows.substring(0, this.Rows.length - 1) + ']';

  //  //this.setRsltType(this.Rows);//, 1);
  //}
}
